import createReactComponent from '../createReactComponent';
export default createReactComponent('chevron-down-right', 'ChevronDownRight', [["path",{"d":"M16.121 7.636v8.485H7.636","key":"svg-0"}]]);